import React, { useState } from "react";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwSelectOption from "../../../shared/OwSelectOption/OwSelectOption";

type Props = {
    onChange: (quickbooksOnline: { hasInvoice?: boolean } | undefined) => void;
};

export const OrdersDetailReportQbo: React.FC<Props> = (props) => {
    const [hasInvoice, setHasInvoice] = useState<boolean | undefined>(undefined);

    const invoiceStatusOptions = [
        { value: "true", title: "has_invoice" },
        { value: "false", title: "no_invoice" },
    ];

    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const value = e.target.value;

        if (value === "") {
            setHasInvoice(undefined);
            props.onChange(undefined);
        } else {
            const boolValue = value === "true";
            setHasInvoice(boolValue);
            props.onChange({ hasInvoice: boolValue });
        }
    };

    return (
        <div className={"mt-3 mb-3 col-12"}>
            <OwLabel title={"quickbooks_online_invoice_status"} />
            <OwSelectOption
                options={invoiceStatusOptions}
                valueProp={"value"}
                titleProp={"title"}
                fn={handleChange}
                name={"qbo_invoice_status"}
                showBlankFirst={true}
                translateTitle={true}
                selectedOption={hasInvoice === undefined ? "" : hasInvoice ? "true" : "false"}
                selectedOptionProp={""}
            />
        </div>
    );
};

export default OrdersDetailReportQbo;
